import Store from 'store/store';
import cached from 'utils/cached';
import { accessNested } from 'utils/utils';

const loadScript = url => new Promise((res, rej) => {
	let script = document.createElement('script');
	script.onload = res;
	script.onerror = rej;
	script.src = url;
	document.head.appendChild(script);
});
const loadStyle = url => new Promise((res, rej) => {
	let link = document.createElement('link');
	link.setAttribute('rel', 'stylesheet');
	link.onload = res;
	link.onerror = rej;
	link.href = url;
	document.head.appendChild(link);
});

// const promiseSequence = (arr, fn) => arr.reduce((p, e) => p.then(() => fn(e)), Promise.resolve());

export const getMapTiler = cached(async () => {
	if (typeof window === 'undefined') {
		return undefined;
	}

	if (window.mapboxgl) {
		return window.mapboxgl;
	}

	return Promise.all([
		loadStyle('https://cdn.maptiler.com/mapbox-gl-js/v1.11.1/mapbox-gl.css'),
		loadScript('https://cdn.maptiler.com/mapbox-gl-js/v1.11.1/mapbox-gl.js')
	]);
});

const getLanguageHelper = cached(async () => {
	if (typeof window === 'undefined') {
		return undefined;
	}
	return loadScript('https://cdn.klokantech.com/openmaptiles-language/v1.0/openmaptiles-language.js');
});

export const mount = async (dom, opts) => {
	if (!dom) {
		return;
	}
	const store = Store.get();
	const mapTilerData = accessNested(store, 'appData.doc.mapStyling.mapTiler') || {};
	const { id, key, language } = mapTilerData;

	await getMapTiler();

	if (language) {
		await getLanguageHelper();
	}

	const userGeo = accessNested(store, 'client.geo', {});
	const location = [userGeo.lon || 51.5074, userGeo.lat || -0.1278];

	const options = Object.assign({
		container: dom,
		style: `https://api.maptiler.com/maps/${id}/style.json?key=${key}`,
		center: location,
		zoom: 10.6
	}, opts);

	const mapTilerMap = new window.mapboxgl.Map(options);
	mapTilerMap.addControl(new window.mapboxgl.NavigationControl(), 'bottom-left');

	if (language) {
		mapTilerMap.setLanguage(language);
	}

	return mapTilerMap;
};
